import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL, GET_FEEDBACK } from '../redux-toolkit/ApiEndpoint';

const Feedback = () => {

    const [feedback, setFeedback] = useState([]);




    const fetchfeedback = async () => {
        try {
            const result = await axios.get(BASE_URL + GET_FEEDBACK);
            setFeedback(result.data.contacts);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    };

    // console.log(feedback, "feedback");


    useEffect(() => {
        fetchfeedback();
    }, []);

    return (
        <>
            <table className="table table-bordered pro-table w-100">
                <thead>
                    <tr>
                        <th>sr</th>
                        <th>Date</th>
                        <th>Name </th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Meassage</th>

                    </tr>
                </thead>
                <tbody>
                    { feedback && feedback.length > 0 ? feedback.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{new Date(item.createdAt).toISOString().split('T')[0]}</td>
                                <td>{item?.name}</td>
                                <td>{item?.email}</td>
                                <td>{item?.phone}</td>
                                <td>{item?.message}</td>
                            </tr>
                        );
                    }) : (
                        <tr>
                            <td colSpan="3" className="text-center">Not available fetchfeedback</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
};

export default Feedback;